import React from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { NAV_LINKS } from "../data/content";

export const Footer = () => (
  <footer
    data-testid="main-footer"
    className="relative z-10 border-t border-white/10 bg-[#020817] pt-20 pb-10"
  >
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16">
        <div className="md:col-span-5">
          <Logo markSize={34} />
          <p className="mt-6 text-[#94A3B8] text-base leading-relaxed max-w-sm">
            The open, invisible infrastructure layer beneath a boundless lakehouse — so your
            team spends effort on insight and action, not on plumbing.
          </p>
          <a
            href="mailto:info@etherlake.ai"
            data-testid="footer-email-link"
            className="mt-6 inline-flex items-center gap-2 text-[#4FC3F7] hover:text-[#00E5FF] transition-colors text-sm"
          >
            <Mail className="w-4 h-4" /> info@etherlake.ai
          </a>
        </div>

        <div className="md:col-span-3 md:col-start-8">
          <h4 className="font-mono-el text-xs tracking-[0.2em] text-[#475569] uppercase mb-5">
            Navigate
          </h4>
          <ul className="space-y-3">
            {NAV_LINKS.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-[#94A3B8] hover:text-white transition-colors text-sm"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-mono-el text-xs tracking-[0.2em] text-[#475569] uppercase mb-5">
            Get Started
          </h4>
          <Link
            to="/contact"
            data-testid="footer-cta-link"
            className="inline-flex items-center gap-1 text-white hover:text-[#4FC3F7] transition-colors text-sm group"
          >
            Become a design partner
            <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>
      </div>

      <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-[#475569] text-xs tracking-wide">
          © {new Date().getFullYear()} EtherLake. Apeiron is in early development.
        </p>
        <p className="text-[#475569] text-xs font-mono-el tracking-[0.2em] uppercase">
          Boundless by name · Open by design
        </p>
      </div>
    </div>
  </footer>
);
